var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V3.99998H22L18 0Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8V4H18L22 8Z",
    fill: "#CBD5E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#4FBAF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38716 13.336V16.992C8.38716 17.6693 8.20849 18.184 7.85116 18.536C7.49916 18.8827 7.00316 19.056 6.36316 19.056C5.67516 19.056 5.12849 18.8667 4.72316 18.488C4.31782 18.1093 4.11516 17.5573 4.11516 16.832H5.86716C5.86716 17.0613 5.90449 17.224 5.97916 17.32C6.05382 17.4107 6.15516 17.456 6.28316 17.456C6.38982 17.456 6.47249 17.4213 6.53116 17.352C6.58982 17.2827 6.61916 17.1627 6.61916 16.992V13.336H8.38716ZM13.7859 15.28C13.7859 15.6373 13.7032 15.9627 13.5379 16.256C13.3726 16.544 13.1272 16.7733 12.8019 16.944C12.4819 17.1147 12.0926 17.2 11.6339 17.2H10.9299V19H9.15391V13.336H11.6339C12.3272 13.336 12.8579 13.512 13.2259 13.864C13.5992 14.216 13.7859 14.688 13.7859 15.28ZM11.4339 15.8C11.8019 15.8 11.9859 15.6267 11.9859 15.28C11.9859 14.9333 11.8019 14.76 11.4339 14.76H10.9299V15.8H11.4339ZM17.8212 15.272C17.7519 15.16 17.6532 15.0747 17.5252 15.016C17.3972 14.952 17.2426 14.92 17.0612 14.92C16.7199 14.92 16.4559 15.032 16.2692 15.256C16.0826 15.4747 15.9892 15.776 15.9892 16.16C15.9892 16.6027 16.0932 16.9333 16.3012 17.152C16.5092 17.3707 16.8292 17.48 17.2612 17.48C17.6719 17.48 18.0026 17.3147 18.2532 16.984H16.8372V15.728H19.7252V17.504C19.4799 17.9253 19.1412 18.288 18.7092 18.592C18.2772 18.8907 17.7306 19.04 17.0692 19.04C16.4826 19.04 15.9706 18.92 15.5332 18.68C15.1012 18.4347 14.7679 18.0933 14.5332 17.656C14.3039 17.2187 14.1892 16.72 14.1892 16.16C14.1892 15.6 14.3039 15.1013 14.5332 14.664C14.7679 14.2267 15.1012 13.888 15.5332 13.648C15.9652 13.4027 16.4719 13.28 17.0532 13.28C17.7946 13.28 18.3972 13.4587 18.8612 13.816C19.3306 14.1733 19.6079 14.6587 19.6932 15.272H17.8212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.c51ee03daa80dc6820667dc6b0b4a091.svg";
export { ForwardRef as ReactComponent };